import { defineFieldDisplay } from "../defines";
import Display from "./display.vue";

export default defineFieldDisplay({
  id: "pageview-display",
  component: Display,
});
